import ExcelJS from "exceljs";

const headings = [
  // "candidate_id",
  "name",
  "candidate_id",
  "religion",
  "nationality_name",
  "company_name",
  "loan_advance",
  "loan_advance_installment",
  "arrival_sector",
  //   "selection_grade",
  //   "basic",
  //   "food",
  //   "fixed_ot",
  //   "hra",
  //   "travel_allowance",
  //   "mobile_allowance",
  //   "air_ticket_allowance",
  //   "additional_ot",
  //   "other_allowance",
  //   "duty_hours",
  //   "fixed_ot_hours",
  //   "duration_of_contract",
  //   "probation_period",
  //   "passport_issue_date",
  //   "passport_expiry_date",
  //   "emergency_contact_person_in_home_country",
  //   "emergency_contact_number_in_home_country",
  //   "covid_vaccine",
  //   "blood_group",
  // "status",
  // "visa_block_number",
  // "visa_reference_number",
  // "visa_stamping_date",
  // "company_id",
  // "sponsor_id",
];


const candidates = [
  {
    passport_number: "VITAE NULLA ELIGENDI",
    actual_profession: "WAITER",
    flight_details: "AIR-INDIA-111",
    country: "INDIA",
    date_of_departure: "10-Dec-2023",
    time_of_departure: "22:12:00",
    date_of_arrival: "11-Dec-2023",
    time_of_arrival: "09:30:00",
    arrival_sector: "TEMPORE ALIAS DOLOR",
    pickup_to_be_arranged: "SLA",
    project_incharge:"Arun"
  },
];

export default function ArrivalEmployeeReport( filename,employeeData) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "SNO.";
  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } }, // Black color
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    if (headings[i] == "job_position_name") {
      titleRow.getCell(i + 2).value = "ACTUAL PROFESSION";
    } else {
      titleRow.getCell(i + 2).value = headings[i]
        ?.split("_")
        ?.join(" ")
        ?.toUpperCase();
    }

    const column = sheet.getColumn(i + 2);
    column.width = 28;
  }

  // Set header height
  sheet.getRow(1).height = 30;

  for (let i = 0; i < employeeData?.length; i++) {
    const row = sheet.getRow(i + 2);
    row.getCell(1).value = i + 1;
    for (let j = 0; j < headings.length; j++) {
      row.getCell(j + 2).value = employeeData[i][headings[j]] || "-";
      //   console.log(candidates[i], HeadingsForRow[j], "exvel data");
    }
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}` : "Candidate Flight Detials";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    +URL.revokeObjectURL(url);
  });
}
